import React, { Component } from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import ReduxThunk from 'redux-thunk';
import { Switch, Route } from 'react-router';
import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware, ConnectedRouter } from 'connected-react-router';
import { I18nextProvider } from 'react-i18next';
import i18next from '../i18next';

import reducers from '../reducers';
import MainContainer from './MainContainer';
import LoginScreen from './LoginScreen';
import ForgottenPassScreen from "./ForgottenPassScreen";
import ResetPassScreen from "./ResetPassScreen";
import CentralOrderDetailsScreen from './central/CentralOrderDetailsScreen';
// This is used for Redux Dev Tool (chrome extension)
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

class App extends Component {
	constructor(props) {
		super(props);

		const language = localStorage.getItem('translationLanguage') ? localStorage.getItem('translationLanguage') : 'en';
		i18next.changeLanguage(language);
	}

	render() {
		const history = createBrowserHistory();
		const store = createStore(
			connectRouter(history)(reducers), // new root reducer with router state
			{},
			// composeEnhancers( // This is used for Redux Dev Tool (chrome extension)
			compose(
				applyMiddleware(
					routerMiddleware(history), // for dispatching history actions
					ReduxThunk
				),
			)
		);

		return (
			<I18nextProvider i18n={i18next}>
				<Provider store={store}>
					<ConnectedRouter history={history}>
						<Switch>
							<Route exact path='/' component={LoginScreen} />
							<Route path='/restaurant/:restaurantId/order/details/:orderId' component={CentralOrderDetailsScreen} />
							<Route path='/forgotten-password' component={ForgottenPassScreen} />
							<Route path='/reset-password' component={ResetPassScreen} />
							<Route path='/' component={MainContainer} />
						</Switch>
					</ConnectedRouter>
				</Provider>
			</I18nextProvider>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js